// extracted by css-extract-rspack-plugin
export default {"button":"_fd87bb93","hidden":"_7d74e78f","enter":"_1ba0362d","enterFromBottom":"_bace02d4","chatIcon":"_95ce5250","chatLabel":"_e5d6677d","container":"_64869042"};